import React from "react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function Login() {
  const handleGoogleLogin = () => {
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="grid lg:grid-cols-2 h-screen bg-white" data-testid="login-page">
      <div className="flex flex-col justify-center px-8 sm:px-16 lg:px-24 py-12">
        <div className="max-w-md w-full">
          <div className="flex items-center gap-2 mb-16">
            <div className="w-8 h-8 rounded-md bg-slate-900 flex items-center justify-center text-white font-display font-bold text-sm">I</div>
            <span className="font-display text-lg font-semibold text-slate-900">INDOCG Nexus</span>
          </div>

          <div className="mb-2 inline-block px-2.5 py-0.5 border border-gray-200 rounded-full text-[11px] uppercase tracking-widest text-gray-500 font-mono">
            PO acknowledgment · industrial
          </div>
          <h1 className="font-display text-3xl sm:text-4xl tracking-tight font-bold text-slate-900 mt-4">
            Decode purchase orders.<br/>
            <span className="text-slate-400">Ship faster.</span>
          </h1>
          <p className="text-sm text-gray-600 mt-6 leading-relaxed">
            Upload any customer PO — PDF or scan — and INDOCG Nexus extracts customer, PO number, dates, part codes and unit prices. Then it breaks each hose assembly down into raw materials so you know exactly what to procure.
          </p>

          <button
            data-testid="google-login-btn"
            onClick={handleGoogleLogin}
            className="mt-12 w-full inline-flex items-center justify-center gap-3 bg-slate-900 text-white hover:bg-slate-800 rounded-md px-4 py-3 text-sm font-medium transition-colors focus:ring-2 focus:ring-slate-300 focus:outline-none"
          >
            <svg width="18" height="18" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path fill="#FFFFFF" d="M21.35 11.1H12v3.2h5.35c-.23 1.4-1.7 4.1-5.35 4.1-3.2 0-5.8-2.65-5.8-5.9s2.6-5.9 5.8-5.9c1.83 0 3.05.78 3.75 1.45l2.55-2.45C16.9 4.05 14.7 3 12 3 6.95 3 3 6.95 3 12s3.95 9 9 9c5.2 0 8.65-3.65 8.65-8.8 0-.6-.05-1.05-.3-1.1z"/>
            </svg>
            Continue with Google
          </button>

          <p className="text-xs text-gray-400 mt-6 font-mono">
            By continuing you agree to the terms of service.
          </p>
        </div>
      </div>

      <div className="hidden lg:block bg-slate-900 relative overflow-hidden">
        <img
          src="https://images.pexels.com/photos/36532643/pexels-photo-36532643.jpeg"
          alt="Hydraulic machinery"
          className="absolute inset-0 w-full h-full object-cover opacity-70"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-slate-900/90 via-slate-900/30 to-transparent" />
        <div className="absolute bottom-12 left-12 right-12 text-white">
          <div className="font-mono text-xs uppercase tracking-widest text-white/60 mb-2">Built for hose assemblers</div>
          <p className="font-display text-2xl font-semibold leading-tight">
            From PO to raw-material list in under a minute.
          </p>
        </div>
      </div>
    </div>
  );
}
